import React, { useEffect, useState } from "react";
import phoneblue from "../../../assets/images/phoneblue.png";
import back from "../../../assets/images/back.png";
import s from "../../../assets/images/s.png";
import { useHistory } from "../../../app-services/lib/router-compat";
import Alert from "@mui/material/Alert";

import CircularProgress from "@mui/material/CircularProgress";
import { AddressSkeleton, DeliveryTypeSkeleton } from "./CheckoutSkeleton";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import AddressBlock, { isSameAddress } from "./AddressBlock";
import AddressPickerDialog from "./AddressPickerDialog";

export default connect((props) => {
  const history = useHistory();
  const [address, setAddress] = useState([]);
  const [billaddress, setBilladdress] = useState([]);
  const [delivery, setDelivery] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState("");
  const [selectedDelivery, setSelectedDelivery] = useState("");
  const [alertFail, setAlertFail] = useState(null);
  const [loading, setLoading] = useState("none");
  // First address fetch shows skeletons; later refreshes keep the spinner
  const [addressLoaded, setAddressLoaded] = useState(false);
  const [pickerOpen, setPickerOpen] = useState(false);
  const [billList, setBillList] = useState([]);
  const [billPickerOpen, setBillPickerOpen] = useState(false);
  useEffect(() => {
    getAllAddressDetails();
  }, []);
  // Bring the error alert at the top of the card into view
  useEffect(() => {
    if (alertFail) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [alertFail]);
  useEffect(() => {
    if (props.store.deliveryDetails && props.store.deliveryDetails.id) {
      setSelectedDelivery(props.store.deliveryDetails.id);
    }
    if (props.store.fulladdress && props.store.fulladdress.id) {
      setSelectedAddress(props.store.fulladdress.id);
    }
  }, []);

  // delete shipping address
  const deleteShippingDetails = (id) => {
    setLoading("flex");
    api.deleteShippingItem(id).then((res) => {
      setLoading("none");
      if (res && res.statusCode === 200) {
        getAllAddressDetails();
      }
    });
  };

  //Get all cities bu country Id
  const getAllAddressDetails = () => {
    setLoading("flex");
    // Always start fresh: drop any previous selection before reloading
    mixins.setStore("fulladdress", {}, props);
    mixins.setStore("BillingAddress", {}, props);
    setSelectedAddress();
    setBilladdress({});
    api
      .getAllAddress()
      .finally(() => setAddressLoaded(true))
      .then((res) => {
        setLoading("none");
        if (
          res &&
          res.statusCode === 200 &&
          res.data &&
          res.data.Addresses &&
          res.data.deliveryTypes
        ) {
          // Sort both lists by id, newest (highest id) first
          const byIdDesc = (a, b) => Number(b.id) - Number(a.id);
          const list = [...res.data.Addresses].sort(byIdDesc);
          const bills = [...(res.data.BillingAddress || [])].sort(byIdDesc);
          mixins.setStore("AddressList", list, props);
          // Pick one added today, else the default, else the most
          // recently added (highest id). Lists are id-desc, so find()
          // returns the newest match.
          const today = new Date().toDateString();
          const addedToday = (o) =>
            !!o.created_at && new Date(o.created_at).toDateString() === today;
          const pickAddress = (arr) =>
            arr.find(addedToday) || arr.find((o) => !!o.default) || arr[0];
          const pickedBill = pickAddress(bills);
          mixins.setStore("BillingAddress", pickedBill || {}, props);
          const picked = pickAddress(list);
          if (picked) {
            mixins.setStore("fulladdress", picked, props);
            setSelectedAddress(picked.id);
          } else {
            mixins.setStore("fulladdress", {}, props);
            setSelectedAddress();
          }
          setAddress(list);
          setDelivery(res.data.deliveryTypes);
          setBillList(bills);
          setBilladdress(pickedBill || {});
        }
      });
  };
  //To select address
  const handleChangeAddress = (id) => {
    setSelectedAddress(id);
    {
      address.length >= 1 &&
        address.map((data, index) => {
          if (data.id === id) {
            mixins.setStore("fulladdress", data, props);
          }
        });
    }
  };
  //To select billing address
  const handleChangeBilling = (data) => {
    setBilladdress(data);
    mixins.setStore("BillingAddress", data, props);
  };
  //To select address
  const handleChangeDelivery = (data) => {
    setSelectedDelivery(data);
    {
      delivery.length >= 1 &&
        delivery.map((value, index) => {
          if (value.id === data) {
            mixins.setStore("deliveryDetails", value, props);
          }
        });
    }
  };
  //onClick Edit Address Button
  const onClickEditAddress = (id) => {
    // console.log("Editable Address:",props.store.AddressList.filter((item)=>(item.id == id))[0]);
    mixins.setStore(
      "EditableAddress",
      props.store.AddressList.filter((item) => item.id == id)[0],
      props,
    );
    handleChangeAddress(id);
    mixins.setStore("deliveryDetails", "", props);
    history.push(`/edit-address/${id}`);
  };
  const onClickPayment = () => {
    if (selectedAddress && selectedDelivery) {
      mixins.setStore("address", selectedAddress, props);
      mixins.setStore("deliverytype", selectedDelivery, props);

      history.push("/payment");
    } else if (selectedAddress) {
      setAlertFail("Please Select Shipping Details");
      setTimeout(() => {
        setAlertFail(null);
      }, 8000);
    } else {
      setAlertFail("Please Choose Your Address");
      setTimeout(() => {
        setAlertFail(null);
      }, 8000);
    }
  };
  useEffect(() => {
    mixins.setStore("EditableAddress", "", props);
  }, []);

  const fetchcountry = (countryname) => {
    if (countryname) {
      let country = countryname == "SG" ? "Singapore" : countryname;
      api
        .fetchgstbycountryname(country)
        .then((res) => {
          if (res.status) {
            let gstdata = {
              countryname: res.data[0]?.name,
              gst_rate: res.data[0]?.gst_rate || 0,
            };
            mixins.setStore("contrywithgst", gstdata, props);
          }
        })
        .catch((rej) => {
          console.log(rej);
        });
    }
  };
  useEffect(() => {
    if (props.store?.fulladdress?.id) {
      let defaultaddress = props.store?.fulladdress;
      let countryname = defaultaddress?.country;
      fetchcountry(countryname);
    } else {
      mixins.setStore("contrywithgst", {}, props);
    }
  }, [props.store?.fulladdress]);
  return (
    <div className="deliverycard">
      {alertFail && (
        <Alert severity="error" variant="filled">
          <strong>{alertFail}</strong>
        </Alert>
      )}
      {addressLoaded && (
        <div style={{ display: loading, margin: "auto" }}>
          <CircularProgress color="success" />
        </div>
      )}
      {!addressLoaded && <AddressSkeleton />}
      {(() => {
        const data =
          address.find((o) => o.id === selectedAddress) || address[0];
        if (!data) return null;
        const hasBilling = !!billaddress?.address1;
        return (
          <div className="delivery-address-panel">
            <div className="delivery-address-panel-head">
              <div className="delivery-address-panel-who">
                <span className="delivery-address-panel-eyebrow">
                  Delivering to
                </span>
                <span className="delivery-address-panel-name">
                  {data.firstName} {data.lastName}
                </span>
              </div>
              <div className="delivery-address-panel-actions">
                <button
                  type="button"
                  className="delivery-ghost-btn"
                  onClick={() => onClickEditAddress(data.id)}
                >
                  <EditOutlinedIcon fontSize="small" />
                  Edit
                </button>
                <button
                  type="button"
                  className="delivery-ghost-btn is-danger"
                  onClick={() => deleteShippingDetails(data.id)}
                >
                  <DeleteOutlineOutlinedIcon fontSize="small" />
                  Delete
                </button>
              </div>
            </div>
            <div className="checkout-address-grid is-horizontal">
              <AddressBlock
                icon={<LocalShippingOutlinedIcon />}
                title="Shipping Address"
                address={data}
                action={
                  address.length > 1 && (
                    <button
                      type="button"
                      className="delivery-change-btn"
                      onClick={() => setPickerOpen(true)}
                    >
                      Change
                      <span className="delivery-change-count">
                        {address.length}
                      </span>
                    </button>
                  )
                }
              />
              <AddressBlock
                icon={<ReceiptLongOutlinedIcon />}
                title="Billing Address"
                address={hasBilling ? billaddress : data}
                badge={
                  !hasBilling || isSameAddress(billaddress, data)
                    ? "Same as shipping"
                    : null
                }
                action={
                  billList.length > 1 && (
                    <button
                      type="button"
                      className="delivery-change-btn"
                      onClick={() => setBillPickerOpen(true)}
                    >
                      Change
                      <span className="delivery-change-count">
                        {billList.length}
                      </span>
                    </button>
                  )
                }
              />
            </div>
          </div>
        );
      })()}
      <AddressPickerDialog
        open={pickerOpen}
        onClose={() => setPickerOpen(false)}
        title="Choose a delivery address"
        list={address}
        selectedId={selectedAddress}
        onSelect={(data) => handleChangeAddress(data.id)}
        onEdit={(data) => onClickEditAddress(data.id)}
        onDelete={(data) => deleteShippingDetails(data.id)}
        onAdd={() => history.push("/shipping-details")}
      />
      <AddressPickerDialog
        open={billPickerOpen}
        onClose={() => setBillPickerOpen(false)}
        title="Choose a billing address"
        list={billList}
        selectedId={billaddress?.id}
        onSelect={handleChangeBilling}
        idPrefix="billing"
      />
      <div className="title">Shipping Details</div>
      <div className="delivery-address-container delivery-speed-list">
        {!addressLoaded && <DeliveryTypeSkeleton />}
        {delivery.length >= 1 &&
          delivery.map((value) => {
            const isSelected = value.id === selectedDelivery;
            return (
              <div
                key={value.id}
                className={`delivery-type-container-row delivery-speed-option${
                  isSelected ? " is-selected" : ""
                }`}
                onClick={() => handleChangeDelivery(value.id)}
              >
                <div className="delivery-type-radio">
                  <input
                    type="radio"
                    checked={isSelected}
                    onChange={() => handleChangeDelivery(value.id)}
                  />
                </div>
                <div className="delivery-type-des">
                  <span className="titles">{value.shippingType}</span>
                  <label className="date">
                    {" "}
                    Estimated delivery: {value.estimatedDelhiveryDate}
                  </label>
                  <span className="info">{value.description}</span>
                </div>
              </div>
            );
          })}
      </div>
      <div className="button-container">
        <button
          className="back-btn"
          onClick={() => {
            history.push("/checkout-page");
          }}
        >
          <span>
            <img src={back} />
            Back to Cart
          </span>
        </button>
        {address.length >= 1 && (
          <button className="continue-btn" onClick={onClickPayment}>
            <span>
              <img src={s} />
              Continue to Payment
            </span>
          </button>
        )}
      </div>
    </div>
  );
});
